
import Vue from 'vue'
import AppBar from "@/components/UI/AppBar/AppBar.vue"
import Footer from '@/components/Footer/Footer.vue'
import HeaderBar from "@/components/UI/HeaderBar/UIHeaderBar.vue"
import { Route } from 'vue-router';
import { RouteInformation, RouteMetaInterface } from '@/routerManagerNew/routes'
import { mapState } from 'vuex';
import AddressSelection from '@/components/AddressSelection.vue';
import InitLoader from '@/components/UI/Loader/InitLoader.vue';


export default Vue.extend({
    components: {
        "app-bar": AppBar,
        "custom-footer": Footer,
        "header-bar": HeaderBar,
        "address-selection": AddressSelection,
        "init-loader": InitLoader,
    },

    data: () => ({
        isLoading: false as  boolean,
        isBackBtnDisplayed: true as boolean
    }),

    computed: {

        ...mapState("partner", ["appDataContent", "partnerSettings"]),
        ...mapState("ui", ["isMobileViewDisplayed", "isSwitchingOrderType"]),
        ...mapState("product", ["isProductDetailsLoading"]),
        ...mapState("store", ["selectedStoreDetails"]),
        ...mapState("user", ["selectedStoreDetails"]),

        pageTitle(): string {
            var routeName = this.route.name;            
            var pageTitle = "";

            switch(routeName) {
                case RouteInformation.Checkout: 
                    pageTitle = "Checkout";
                    this.isBackBtnDisplayed = true;
                    break;

                case RouteInformation.OrdersPage: 
                    pageTitle = "Orders";
                    this.isBackBtnDisplayed = true;
                    break;

                case RouteInformation.OrderSummaryPage: 
                    pageTitle =  `#${this.route.params["orderId"]}`;
                    this.isBackBtnDisplayed = true;
                    break;

                case "DynamicFooterPage": 
                    pageTitle =  `${this.route.params["footerPageName"]}`;
                    this.isBackBtnDisplayed = true;
                    break;

                case RouteInformation.ProfilePage: 
                    pageTitle =  "Account Details";
                    this.isBackBtnDisplayed = true;
                    break;

                case RouteInformation.WalletPage: 
                    pageTitle =  "Wallet";
                    this.isBackBtnDisplayed = true;
                    break;

                case RouteInformation.LoyaltyPage: 
                    pageTitle =  (this as any).appDataContent.loyaltyProgramTitleText.replace('{1}', (this as any).partnerSettings.partnerName);
                    this.isBackBtnDisplayed = true;
                    break;

                case RouteInformation.ContactUsPage: 
                    pageTitle =  "Contact Us";
                    this.isBackBtnDisplayed = true;
                    break;

                case RouteInformation.OrderReplacement: 
                    pageTitle =  "Out of Stock Items";
                    break;
            }

            return pageTitle;
        },

    
        whatsappPhoneNumber(): string | null {
            if(this.selectedStoreDetails.id > 0 && this.selectedStoreDetails.whatsAppNumbers.length > 0)
            {
                return this.selectedStoreDetails.whatsAppNumbers[0];
            }

            else if(this.partnerSettings.customerServiceWhatsAppNumber.length > 0) 
            {
                return this.partnerSettings.customerServiceWhatsAppNumber
            }
            else return null;
        },

        // get the route
        route(): Route {
            return this.$route;
        },

        // check if route has app bar
        isAppBarDisplayed(): boolean{            
            if(this.isMobileViewDisplayed == true && (this.$route.name == "storesPage" ||this.$route.name == "storeHomePage")) {
                return true;
            }

            return (this.route.meta as RouteMetaInterface).includeAppBar;
        },

        // check if route has light app bar
        isAppBarLight(): boolean{
            return (this.route.meta as RouteMetaInterface).hasLightAppBar;
        },

        // check if footer is displayed
        isFooterDisplayed(): boolean{
            return (this.route.meta as RouteMetaInterface).includeFooter;
        },
        
    },

    methods: {
        updateLoadingState(val: boolean) {
            this.isLoading = val;
        }
    },

    watch: {
        isProductDetailsLoading(val: boolean) {
            this.updateLoadingState(val)
        } 
    },

    
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if(to.name == RouteInformation.OrderReplacement) {
                if(from.name == RouteInformation.OrderSummaryPage)
                    (vm as any).isBackBtnDisplayed = true;
                else 
                    (vm as any).isBackBtnDisplayed = false;
            }

            else {
                (vm as any).isBackBtnDisplayed = true;
            }
        });
    },
    
})
